import SearchResults from '../entities/SearchResults';
import getSearchResults from '../api/getSearchResults';

export interface SearchServiceInterface {
  search(searchTerm: string): Promise<SearchResults | null>;
}

let instance: SearchServiceInterface | null = null;

class SearchService implements SearchServiceInterface {
  private controller: AbortController | null = null;

  async search(searchTerm: string): Promise<SearchResults | null> {
    this.controller?.abort();
    this.controller = new AbortController();

    try {
      return await getSearchResults(searchTerm, {
        signal: this.controller.signal,
      });
    } catch (err) {
      if (err instanceof Error && err.name === 'AbortError') {
        return null;
      }

      throw err;
    }
  }
}

export default function getInstance(): SearchServiceInterface {
  if (instance === null) {
    instance = new SearchService();
  }

  return instance;
}
